import { gtmTrack } from '../../track';

const CONVERSATION_SOURCES = [
  'profile', 'ama', 'groups page', 'url', 'list', 'hidden list', 'blocked list',
  'public groups', 'search', 'favorite', 'member', 'new dm', 'new group', 'unknown'
];

// Mirrors the Chat::Status preset enum.
const STATUS_PRESETS = [
  'open_to_chat', 'lets_collaborate', 'busy_now', 'ask_me_anything', 'here_to_support', 'slow_to_respond'
];

// Code form of docs/analytics/chat-events.md: component → action → the only
// `text` values allowed (empty when the event carries none). Anything off the
// list is dropped so free text or identifiers can never reach GA.
const CHAT_EVENTS = {
  chat: { open: ['nav', 'floating-button'] },
  conversation: { open: CONVERSATION_SOURCES },
  'group conversation': { open: CONVERSATION_SOURCES },
  message: {
    send: ['text', 'image', 'voice', 'video', 'file'],
    edit: [],
    delete: ['for me', 'for everyone']
  },
  reply: { send: [] },
  mention: { send: [] },
  reactions: { add: [] },
  favorites: { add: [], 'open list': [] },
  translate: { click: [] },
  group: { create: [], join: [], 'request to join': [], leave: [] },
  'public groups': { open: [] },
  search: { submit: [], 'select result': [] },
  status: { set: [...STATUS_PRESETS, 'custom'] },
  'active status': { toggle: [] },
  'voice message': { 'record start': [], cancel: [] },
  'alt text': { generate: [] },
  moderation: { report: [], block: [] },
  inbox: { hide: [], 'mark read': [], 'mark unread': [] }
};

function isAllowed(component, action, text) {
  const allowedText = CHAT_EVENTS[component]?.[action];
  if (!allowedText) return false;
  return text === undefined ? allowedText.length === 0 : allowedText.includes(text);
}

// Bypasses track.js's page-load grace period, which exists for x-effect
// expressions; chat events only ever come from explicit calls.
export function trackChatEvent(component, action, text, { section }) {
  if (!isAllowed(component, action, text)) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('chat analytics: dropped event not in the dictionary', { component, action, text });
    }
    return;
  }

  gtmTrack({
    event: 'chat',
    name: 'onclick',
    type: 'click',
    region: 'chat',
    section,
    component,
    action,
    ...(text !== undefined && { text })
  });
}

export function chatAnalytics() {
  return {
    analyticsSection: 'overlay',

    trackChat(component, action, text) {
      trackChatEvent(component, action, text, { section: this.analyticsSection });
    },

    trackMessageSend(type, { replyTo, mentions }) {
      this.trackChat('message', 'send', type);
      if (replyTo) this.trackChat('reply', 'send');
      if (mentions?.length) this.trackChat('mention', 'send');
    }
  };
}
